var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "footer",
    { staticClass: "grey darken-4 pt-8 white--text pb-14 pb-md-10 pb-lg-0" },
    [
      _c(
        "v-container",
        {},
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "8", md: "6", lg: "3" } },
                [
                  _c(
                    "div",
                    { staticClass: "border-bottom pb-7 border-gray-800 mb-6" },
                    [
                      _c("img", {
                        staticStyle: { width: "150px" },
                        attrs: { src: _vm.data?.footer_logo },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("ul", { staticClass: "list-unstyled ps-0 fs-13 mb-3" }, [
                    _c("li", { staticClass: "py-1" }, [
                      _vm._v(
                        _vm._s(_vm.$optional("data.company_info?.company_name"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "py-1" }, [
                      _vm._v(
                        "대표 : " +
                          _vm._s(_vm.$optional("data.company_info?.ceo_name"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "py-1" }, [
                      _vm._v(
                        "사업자번호 : " +
                          _vm._s(_vm.$optional("data.company_info?.biz_number"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "py-1" }, [
                      _vm._v(
                        "통신판매번호 : " +
                          _vm._s(
                            _vm.$optional(
                              "data.company_info?.online_sales_license_number"
                            )
                          )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "py-1" }, [
                      _vm._v(
                        "웹하드 : " +
                          _vm._s(
                            _vm.$optional("data.company_info?.webhard_id")
                          ) +
                          " / " +
                          _vm._s(_vm.$optional("data.company_info?.webhard_pw"))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  false
                    ? _c(
                        "div",
                        [
                          _c(
                            "div",
                            { staticClass: "primary--text fs-14 fw-700 mb-1" },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t(
                                      "get_your_special_offers_coupons__more"
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-form",
                            {
                              attrs: { "lazy-validation": "" },
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                  return _vm.subscribe()
                                },
                              },
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "white mb-2",
                                attrs: {
                                  placeholder: _vm.$t("your_email_address"),
                                  type: "email",
                                  "error-messages": _vm.emailErrors,
                                  "hide-details": "auto",
                                  required: "",
                                  outlined: "",
                                },
                                model: {
                                  value: _vm.subscribeForm.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.subscribeForm, "email", $$v)
                                  },
                                  expression: "subscribeForm.email",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "px-12 mb-4",
                                  attrs: {
                                    elevation: "0",
                                    type: "submit",
                                    color: "primary",
                                    loading: _vm.subscribeFormLoading,
                                    disabled: _vm.subscribeFormLoading,
                                    outlined: "",
                                  },
                                  on: { click: _vm.subscribe },
                                },
                                [_vm._v(_vm._s(_vm.$t("subscribe")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "mb-5 d-none d-lg-block",
                  attrs: { lg: "2", cols: "12", "offset-lg": "1" },
                },
                [
                  _c("h4", { staticClass: "primary--text mb-4" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$optional("data.footer_link_one?.title")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "list-unstyled ps-0 fs-13" },
                    _vm._l(
                      _vm.$optional("data.footer_link_one?.menu"),
                      function (link, label, i) {
                        return _c(
                          "li",
                          { key: i, staticClass: "py-2" },
                          [
                            _c(
                              "dynamic-link",
                              {
                                attrs: {
                                  to: link,
                                  "append-class": "text-reset",
                                },
                              },
                              [_vm._v(_vm._s(label))]
                            ),
                          ],
                          1
                        )
                      }
                    ),
                    0
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "mb-5 d-none d-lg-block",
                  attrs: { lg: "4", cols: "12" },
                },
                [
                  _c("h4", { staticClass: "primary--text mb-4" }, [
                    _vm._v(_vm._s(_vm.$t("contact_us"))),
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "list-unstyled ps-0 fs-13" }, [
                    _c("li", { staticClass: "py-2 mb-2" }, [
                      _c("div", { staticClass: "opacity-50" }, [
                        _c("i", { staticClass: "las la-home me-3 mb-2" }),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("address")) +
                            "\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$optional(
                                "data.contact_info?.contact_address"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "py-2 mb-2" }, [
                      _c("div", { staticClass: "opacity-50" }, [
                        _c("i", { staticClass: "las la-envelope me-3 mb-2" }),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("email")) +
                            "\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$optional("data.contact_info?.contact_email")
                            ) +
                            "\n                        "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "py-2 mb-2" }, [
                      _c("div", { staticClass: "opacity-50" }, [
                        _c("i", { staticClass: "las la-phone me-3 mb-2" }),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("phone")) +
                            "\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$optional("data.contact_info?.contact_phone")
                            ) +
                            "\n                        "
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              false
                ? _c(
                    "v-col",
                    {
                      staticClass: "mb-5 d-none d-lg-block",
                      attrs: { lg: "2", cols: "12" },
                    },
                    [
                      _c("h4", { staticClass: "primary--text mb-4" }, [
                        _vm._v(_vm._s(_vm.$t("mobile_apps"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "d-inline-block pt-2",
                          attrs: {
                            href: _vm.$optional(
                              "data.mobile_app_links?.play_store"
                            ),
                            target: "_blank",
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "mw-100",
                            attrs: {
                              src: _vm.static_asset(
                                "/assets/img/play_store.png"
                              ),
                              height: "40",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "d-inline-block pt-2",
                          attrs: {
                            href: _vm.$optional(
                              "data.mobile_app_links?.app_store"
                            ),
                            target: "_blank",
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "mw-100",
                            attrs: {
                              src: _vm.static_asset(
                                "/assets/img/app_store.png"
                              ),
                              height: "40",
                            },
                          }),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-col",
                { staticClass: "d-lg-none mb-5", attrs: { cols: "12" } },
                [
                  _c(
                    "v-expansion-panels",
                    { attrs: { flat: "", accordion: "" } },
                    [
                      _c(
                        "v-expansion-panel",
                        {
                          staticClass:
                            "transparent white--text border-bottom border-gray-800",
                        },
                        [
                          _c(
                            "v-expansion-panel-header",
                            {
                              staticClass: "px-0",
                              attrs: {
                                "expand-icon":
                                  "la-angle-down white--text fs-14",
                              },
                            },
                            [
                              _c("h4", { staticClass: "primary--text mb-0" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$optional(
                                        "data.footer_link_one?.title"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-expansion-panel-content", {}, [
                            _c(
                              "ul",
                              { staticClass: "list-unstyled ps-0 fs-13" },
                              _vm._l(
                                _vm.$optional("data.footer_link_one?.menu"),
                                function (link, label, i) {
                                  return _c(
                                    "li",
                                    { key: i, staticClass: "py-2" },
                                    [
                                      _c(
                                        "dynamic-link",
                                        {
                                          attrs: {
                                            to: link,
                                            "append-class": "text-reset",
                                          },
                                        },
                                        [_vm._v(_vm._s(label))]
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-expansion-panel",
                        {
                          staticClass:
                            "transparent white--text border-bottom border-gray-800",
                        },
                        [
                          _c(
                            "v-expansion-panel-header",
                            {
                              staticClass: "px-0",
                              attrs: {
                                "expand-icon":
                                  "la-angle-down white--text fs-14",
                              },
                            },
                            [
                              _c("h4", { staticClass: "primary--text mb-0" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$optional(
                                        "data.footer_link_two?.title"
                                      )
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-expansion-panel-content", {}, [
                            _c(
                              "ul",
                              { staticClass: "list-unstyled ps-0 fs-13" },
                              _vm._l(
                                _vm.$optional("data.footer_link_two?.menu"),
                                function (link, label, i) {
                                  return _c(
                                    "li",
                                    { key: i, staticClass: "py-2" },
                                    [
                                      _c(
                                        "dynamic-link",
                                        {
                                          attrs: {
                                            to: link,
                                            "append-class": "text-reset",
                                          },
                                        },
                                        [_vm._v(_vm._s(label))]
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-expansion-panel",
                        {
                          staticClass:
                            "transparent white--text border-bottom border-gray-800",
                        },
                        [
                          _c(
                            "v-expansion-panel-header",
                            {
                              staticClass: "px-0",
                              attrs: {
                                "expand-icon":
                                  "la-angle-down white--text fs-14",
                              },
                            },
                            [
                              _c("h4", { staticClass: "primary--text mb-0" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("contact_us")) +
                                    "\n                            "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-expansion-panel-content", {}, [
                            _c(
                              "ul",
                              { staticClass: "list-unstyled ps-0 fs-13" },
                              [
                                _c("li", { staticClass: "py-2 mb-2" }, [
                                  _c("div", { staticClass: "opacity-50" }, [
                                    _c("i", {
                                      staticClass: "las la-home me-3 mb-2",
                                    }),
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.$t("address")) +
                                        "\n                                    "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$optional(
                                            "data.contact_info?.contact_address"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("li", { staticClass: "py-2 mb-2" }, [
                                  _c("div", { staticClass: "opacity-50" }, [
                                    _c("i", {
                                      staticClass: "las la-envelope me-3 mb-2",
                                    }),
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.$t("email")) +
                                        "\n                                    "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$optional(
                                            "data.contact_info?.contact_email"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("li", { staticClass: "py-2 mb-2" }, [
                                  _c("div", { staticClass: "opacity-50" }, [
                                    _c("i", {
                                      staticClass: "las la-phone me-3 mb-2",
                                    }),
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.$t("phone")) +
                                        "\n                                    "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$optional(
                                            "data.contact_info?.contact_phone"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      false
                        ? _c(
                            "v-expansion-panel",
                            { staticClass: "transparent white--text" },
                            [
                              _c(
                                "v-expansion-panel-header",
                                {
                                  staticClass: "px-0",
                                  attrs: {
                                    "expand-icon":
                                      "la-angle-down white--text fs-14",
                                  },
                                },
                                [
                                  _c(
                                    "h4",
                                    { staticClass: "primary--text mb-0" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("mobile_apps")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-expansion-panel-content", {}, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "d-inline-block pt-2",
                                    attrs: {
                                      href: _vm.$optional(
                                        "data.mobile_app_links?.play_store"
                                      ),
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "mw-100",
                                      attrs: {
                                        src: _vm.static_asset(
                                          "/assets/img/play_store.png"
                                        ),
                                        height: "40",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "d-inline-block pt-2",
                                    attrs: {
                                      href: _vm.$optional(
                                        "data.mobile_app_links?.app_store"
                                      ),
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "mw-100",
                                      attrs: {
                                        src: _vm.static_asset(
                                          "/assets/img/app_store.png"
                                        ),
                                        height: "40",
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "py-3 border-top border-bottom border-gray-800" },
            [
              _c(
                "ul",
                { staticClass: "list-unstyled d-flex flex-wrap ps-0" },
                _vm._l(
                  _vm.$optional("data?.footer_menu"),
                  function (link, label, i) {
                    return _c(
                      "li",
                      {
                        key: i,
                        class: [
                          "py-2 pe-4 pe-md-7",
                          { "ps-md-3 ps-md-7": i !== 0 },
                        ],
                      },
                      [
                        _c(
                          "dynamic-link",
                          { attrs: { to: link, "append-class": "text-reset" } },
                          [
                            _c("span", {
                              domProps: { innerHTML: _vm._s(label) },
                            }),
                          ]
                        ),
                      ],
                      1
                    )
                  }
                ),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "v-row",
            { staticClass: "py-5" },
            [
              _c("v-col", { attrs: { md: "7", cols: "12" } }, [
                _c("div", {
                  staticClass: "lh-1 fs-13",
                  domProps: {
                    innerHTML: _vm._s(_vm.$optional("data?.copyright_text")),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("v-col", { attrs: { md: "5", cols: "12" } }, [
                _c(
                  "ul",
                  {
                    staticClass:
                      "list-unstyled d-flex justify-start justify-md-end mt-2 ps-0",
                  },
                  _vm._l(
                    _vm.$optional("data?.social_link"),
                    function (link, label, i) {
                      return _c(
                        "li",
                        { key: i, class: ["social-icon", { "ms-2": i != 0 }] },
                        [
                          _c(
                            "a",
                            {
                              class: label,
                              attrs: { href: link, target: "_blank" },
                            },
                            [
                              _c("i", {
                                class: { lab: true, ["la-" + label]: true },
                              }),
                            ]
                          ),
                        ]
                      )
                    }
                  ),
                  0
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }